import { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import './ProjectModal.css';

const ProjectModal = ({ project, onClose }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    setIndex(0);
  }, [project]);

  useEffect(() => {
    if (!project) return undefined;

    const onKey = (event) => {
      if (event.key === 'Escape') onClose();
      if (event.key === 'ArrowRight') {
        setIndex((value) => (value + 1) % project.images.length);
      }
      if (event.key === 'ArrowLeft') {
        setIndex((value) => (value - 1 + project.images.length) % project.images.length);
      }
    };

    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKey);
    };
  }, [project, onClose]);

  if (!project) return null;

  const images = project.images || [];
  const prev = () => setIndex((value) => (value - 1 + images.length) % images.length);
  const next = () => setIndex((value) => (value + 1) % images.length);

  return (
    <div className="modal" role="dialog" aria-modal="true" aria-label={project.title}>
      <button type="button" className="modal__backdrop" aria-label="Close dialog" onClick={onClose} />
      <div className="modal__panel">
        <button type="button" className="modal__close" onClick={onClose} aria-label="Close">
          <CloseIcon />
        </button>

        <div className="modal__gallery">
          {images.length > 0 && <img src={images[index]} alt={`${project.title} screenshot`} />}
          {images.length > 1 && (
            <>
              <button type="button" className="modal__nav modal__nav--prev" onClick={prev} aria-label="Previous image">
                <ChevronLeftIcon />
              </button>
              <button type="button" className="modal__nav modal__nav--next" onClick={next} aria-label="Next image">
                <ChevronRightIcon />
              </button>
              <div className="modal__dots" aria-hidden="true">
                {images.map((image, imageIndex) => (
                  <button
                    key={image}
                    type="button"
                    className={imageIndex === index ? 'is-active' : ''}
                    onClick={() => setIndex(imageIndex)}
                  />
                ))}
              </div>
            </>
          )}
        </div>

        <div className="modal__content">
          <span className="projects__tag">{project.tag}</span>
          <h3>{project.title}</h3>
          <p className="modal__caption">{project.caption}</p>
          <p className="modal__description">{project.description}</p>

          {project.tech?.length > 0 && (
            <ul className="projects__tech modal__tech">
              {project.tech.map((tech) => (
                <li key={tech}>{tech}</li>
              ))}
            </ul>
          )}

          {project.links?.length > 0 && (
            <div className="modal__links">
              {project.links.map((link) => {
                const Icon = link.icon;
                return (
                  <a key={link.href} href={link.href} target="_blank" rel="noreferrer" className="btn btn-primary">
                    {Icon && <Icon fontSize="small" />}
                    {link.label}
                  </a>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectModal;
